export function getCookie(name: string) {
  const value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return value ? decodeURIComponent(value[2]) : ''
}
